<!--
  v1.0
  Composant: b122-login

  Props:
    logo: Nom du logo à ranger dans client/src/assets/images/ (défaut: logo.svg)
    background: Nom de l'image de fond à poser dans client/src/assets/images (défaut: login-background.png)
    login-title: Titre de la page login (défaut: Bienvenue)
    login-subtitle: Sous-titre de la page login (défaut: Connectez-vous pour continuer.)
    forgot-title: Titre de la page forgot (défaut: Réinitialiser le mot de passe)
    forgot-subtitle: Sous-titre de la page forgot (défaut: Entrez votre email et vous recevrez un email de réinitilisation de mot de passe)
    login-first-credential: Premier identifiant (défaut: email)
    login-second-credential: Second identifiant (défaut: mot de passe)
    button-text: Texte du bouton login(défaut: "Se connecter")
    forgot-button-text: Texte du bouton forgot (défaut: "Réinitialiser le mot de passe)
    forgot-password-text: Texte du lien vers la page de réinitialisation (défaut: "Mot de passe oublié ?")
    back-text: Texte du lien vers le retour au login (défaut: Retour à la connexion)
    show-forgot-password: Présence du lien vers la page de réinitialisation (défaut: true)

-->
<template>
  <div>
    <div>
      <div class="row no-gutters">
        <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 loginPage">
          <div class="w-100">
            <!-- _________________________ LOGIN _________________________ -->
            <div id="login-div" v-if="!toggle">

              <div>
                <img class="logo-img" :src="require(`@/assets/images/b122/${logo}`)" alt="Logo Login">
              </div>

              <h1 class="mt-4">
                <b>{{ loginTitle }} </b>
              </h1>
              <h2>
                {{ loginSubtitle }}
              </h2>

              <form @submit.stop.prevent="handleSubmit" class="mt-4">

                <b-alert :show="showError" variant="danger">Email ou mot de passe incorrect</b-alert>

                <b-form-group
                  :label="loginFirstCredential"
                  label-for="username-input"
                >
                  <b-form-input
                    class="input-login"
                    id="username-input"
                    v-model="form.username.value"
                    type="email"
                    required
                    @keydown="hideError"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  :label="loginSecondCredential"
                  label-for="password-input"
                >
                  <b-form-input
                    class="input-login"
                    id="password-input"
                    v-model="form.password.value"
                    type="password"
                    required
                    @keydown="hideError"
                  ></b-form-input>
                </b-form-group>

                <div class="mt-4">
                  <b-button type="submit" class="btn-block" variant="primary"> <b> {{ buttonText }} </b> </b-button>
                </div>

              </form>
              <div class="row justify-content-between">
                <b-form-checkbox
                  class="mt-4 ml-3 forgot-password-link"
                  id="remember_me"
                  v-model="form.rememberMe.value"
                >
                  Se souvenir de moi
                </b-form-checkbox>

                <div class="mt-4 text-right" v-if="showForgotPassword">
                  <b-link v-on:click="toggle = !toggle" class="forgot-password-link">{{ forgotPasswordText }}</b-link>
                </div>
              </div>
            </div>

            <!-- _________________________ FORGOT PASSWORD _________________________ -->
            <div id="forgot-password-div" v-if="toggle">
              <div>
                <img class="logo-img" :src="require(`@/assets/images/b122/${logo}`)" alt="Logo Login">
              </div>

              <h1 class="mt-4">
                {{ forgotTitle }}
              </h1>
              <h2>
                {{ forgotSubtitle }}
              </h2>

              <form @submit.stop.prevent="handleForgotSubmit" class="mt-4">

                <b-alert :show="ui.showSuccess" variant="success">
                  Si votre adresse email existe dans notre base de données, vous recevrez un nouveau mot de passe à cette adresse dans quelques minutes.
                </b-alert>

                <b-alert :show="ui.showError" variant="danger">
                  Une erreur est survenue, essayez à nouveau.
                </b-alert>

                <b-form-group
                  :label="forgotCredential"
                  label-for="username-input"
                >
                  <b-form-input
                    id="username-input"
                    v-model="form.username.value"
                    type="email"
                    required
                    @keydown="hideMessages"
                  ></b-form-input>
                </b-form-group>

                <div class="mt-4">
                  <b-button type="submit" class="btn-block" variant="primary">{{ forgotButtonText }}</b-button>
                </div>

              </form>

              <div class="mt-4 text-right">
                <b-link v-on:click="toggle = !toggle" class="forgot-password-link">{{ backText }}</b-link>
              </div>
            </div>

          </div>

        </div>
        <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-8 d-lg-block d-xl-block" :style="{'background-image': 'url(' + require(`@/assets/images/b122/${background}`) + ')'}">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import api from "../../services/api";

export default {
  name: 'b122-login',

  props: {
    logo: {
      type: String,
      default: 'logo.png'
    },
    background: {
      type: String,
      default: 'login-background.png'
    },
    loginTitle: {
      type: String,
      default: 'Bienvenue'
    },
    loginSubtitle: {
      type: String,
      default: 'Connectez-vous pour continuer.'
    },
    forgotTitle: {
      type: String,
      default: 'Réinitialiser le mot de passe'
    },
    forgotSubtitle: {
      type: String,
      default: 'Entrez votre email et vous recevrez un email de réinitialisation de mot de passe.'
    },
    loginFirstCredential: {
      type: String,
      default: 'Email'
    },
    loginSecondCredential: {
      type: String,
      default: 'Mot de passe'
    },
    forgotCredential: {
      type: String,
      default: 'Email'
    },
    buttonText: {
      type: String,
      default: 'Se connecter'
    },
    forgotPasswordText: {
      type: String,
      default: 'Mot de passe oublié ?'
    },
    forgotButtonText: {
      type: String,
      default: 'Réinitialiser le mot de passe'
    },
    backText: {
      type: String,
      default: 'Retour à la connexion'
    },
    showForgotPassword: {
      type: Boolean,
      default: true
    }

  },

  data() {
    return {
      username: this.$route.params.username,
      password: this.$route.params.password,
      toggle: false,
      form: {
        username: {
          value: null
        },
        password: {
          value: null
        },
        rememberMe: {
          value: null
        }
      },
      ui: {
        showSuccess: false,
        showError: false
      },
      showError: false
    };
  },

  mounted() {
    this.prefill()
  },

  methods: {

    ...mapActions(["LogIn", "setRememberMe"]),

    prefill() {
      if (this.username && this.username.trim() !== "") {
        this.form.username.value = this.username
      }
      if (this.password && this.password.trim() !== "") {
        this.form.password.value = this.password
      }
    },

    async handleSubmit() {

      try {

        var data = {
          username: this.form.username.value.trim(),
          password: this.form.password.value.trim()
        };

        this.setRememberMe(this.form.rememberMe.value);
        await this.LogIn(data);

        this.showError = false
        this.goToHome()

      } catch (error) {
        this.showError = true
      }
    },

    handleForgotSubmit() {

      this.ui.showSuccess = false
      this.ui.showError = false

      var formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/resetPassword`,
        data: formData
      })
        .then((response) => {
          this.ui.showSuccess = true
        })
        .catch((response) => {
          this.ui.showError = true
        })
    },

    hideMessages() {
      this.ui.showSuccess = false
      this.ui.showError = false
    },

    hideError() {
      this.showError = false
    },

    goToHome() {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>

<style scoped>

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5%;
  padding-left: 5%;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none;
  }
  #col-left-with-text {
    display: block;
  }
  .w-100 {
    min-height: 100vh;
    margin-top: min(150px, 50%);
  }
  .logo-img {
    max-width: 400px;
  }
  #login-div {
    margin-top: 300px;
  }
  #forgot-password-div {
    margin-top: 300px;
  }
}

@media (max-height: 700px) {
  .w-100 {
    margin-top: min(150px,50%);
  }

  #col-right-with-image {
    height: 100vh;
  }
}


.logo-img {
  max-height: 140px;
  position: absolute;
  left: 0;
  top: 10%;
  width: 80%;
}

h1 {
  font-size: var(--title-level-one-font-size);
}

h2 {
  font-size: var(--title-level-two-font-size);
}

.forgot-password-link {
  color: var(--secondary-text-color);
}

.input-login {
  background-color: #81c8b6 !important;
}

.loginPage {
  background-color: var(--secondary-color);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/B122Login.vue